var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-list-item",
    {
      on: {
        click: function($event) {
          _vm.isFormOpened = !_vm.isFormOpened
        }
      }
    },
    [
      _c("span", { staticClass: "settings__item-text text_large" }, [
        _vm._v(_vm._s(_vm.i18n.set_change_password()))
      ]),
      _vm._v(" "),
      _c("md-icon", { staticClass: "md-icon--half-sized" }, [
        _vm._v("keyboard_arrow_right")
      ]),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          staticClass: "change-password__dialog settings-dialog",
          attrs: {
            "md-active": _vm.isFormOpened,
            "md-click-outside-to-close": !_vm.isPending
          },
          on: {
            "update:mdActive": function($event) {
              _vm.isFormOpened = $event
            },
            "update:md-active": function($event) {
              _vm.isFormOpened = $event
            }
          }
        },
        [
          _vm.isPending
            ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "text_large" }, [
            _vm._v(_vm._s(_vm.i18n.set_change_password()))
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "settings-dialog__content" },
                [
                  _c("input-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:6",
                        expression: "'required|min:6'"
                      }
                    ],
                    attrs: {
                      id: "settings-password",
                      name: "password",
                      type: "password",
                      togglePassword: true,
                      label: _vm.i18n.lbl_new_pwd(),
                      errorMessage: _vm.errorMessage("password"),
                      "data-vv-as": _vm.i18n.signup_password()
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password"
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      id: "settings-confirm-password",
                      name: "confirm-password",
                      type: "password",
                      label: _vm.i18n.lbl_pwd_confirm(),
                      errorMessage: _vm.pwdUnconfirmedMessage
                    },
                    model: {
                      value: _vm.form.confirmPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "confirmPassword", $$v)
                      },
                      expression: "form.confirmPassword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-wrap space-between margin-top" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "btn md-primary",
                      attrs: { type: "button", disabled: _vm.isPending },
                      on: {
                        click: function($event) {
                          _vm.isFormOpened = !_vm.isFormOpened
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.i18n.lbl_cancel()) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "btn md-primary",
                      attrs: { type: "submit", disabled: _vm.isPending }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.i18n.lbl_submit()) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25112c36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25112c36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/settings/security/Security.ChangePassword.vue
// module id = eEzP
// module chunks = 1